import { render } from "./TelegramWorkspace.vue?vue&type=template&id=4a212185&scoped=true"
import script from "./TelegramWorkspace.vue?vue&type=script&lang=js"
export * from "./TelegramWorkspace.vue?vue&type=script&lang=js"

import "./TelegramWorkspace.vue?vue&type=style&index=0&id=4a212185&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a212185"]])

export default __exports__